import React from 'react'

function isChunkLoadError(error) {
  return (
    error?.name === 'ChunkLoadError' ||
    error?.message?.includes('Failed to fetch dynamically imported module') ||
    error?.message?.includes('Loading chunk') ||
    error?.message?.includes('Loading CSS chunk')
  )
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error) {
    if (isChunkLoadError(error)) {
      const hasReloaded = sessionStorage.getItem('chunk-reload')
      if (!hasReloaded) {
        sessionStorage.setItem('chunk-reload', '1')
        window.location.reload()
        return { hasError: false }
      }
    }
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo)
    this.setState({ error, errorInfo })
  }

  componentDidMount() {
    sessionStorage.removeItem('chunk-reload')
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="h-screen flex items-center justify-center bg-gray-50 p-4">
          <div className="max-w-2xl w-full bg-white rounded-lg shadow-lg p-6">
            <h2 className="text-2xl font-bold text-red-600 mb-4">Something went wrong</h2>
            <p className="text-gray-600 mb-4">
              {isChunkLoadError(this.state.error)
                ? 'A new version of the app is available. Please reload.'
                : 'An unexpected error occurred.'}
            </p>
            <details className="mb-4">
              <summary className="cursor-pointer text-gray-700 font-medium">Error details</summary>
              <pre className="mt-2 text-sm bg-gray-100 p-4 rounded overflow-auto">
                {this.state.error && this.state.error.toString()}
                {this.state.errorInfo && this.state.errorInfo.componentStack}
              </pre>
            </details>
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Reload page
            </button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary 